import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const WhyChoose = () => {
  const features = [
    {
      icon: <img src="/why-choose/arrow-down-05-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Start at Low Cost" />,
      title: "Start at Low Cost",
      description: "Begin saving in gold without large commitments — grow at your own pace."
    },
    {
      icon: <img src="/why-choose/delivery-secure-02-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Convert to Physical Gold" />,
      title: "Convert to Physical Gold",
      description: "Enjoy the flexibility to switch from digital to real gold whenever you choose"
    },
    {
      icon: <img src="/why-choose/gold-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Gold Delivered Securely" />,
      title: "Gold Delivered Securely",
      description: "Your gold, delivered to your doorstep—safely and efficiently"
    },
    {
      icon: <img src="/why-choose/halal-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Shariah-Compliant"/>,
      title: "Shariah-Compliant",
      description: "Invest ethically with a 100% interest-free, compliant platform"
    },
    {
      icon: <img src="/why-choose/live-streaming-01-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Live Market Rates"/>,
      title: "Live Market Rates",
      description: "Track real-time prices sourced directly from Dubai Jewellery Group"
    },
    {
      icon: <img src="/why-choose/shield-key-stroke-rounded-1.svg" className="w-12 h-12 text-[#11478e]" alt="Vaulted & Insured"/>,
      title: "Vaulted & Insured",
      description: "Your gold is stored in high-security vaults and is fully insured"
    }
  ];

  return (
    <section className=" mt-10 md:py-4 md:pt-8 md:mt-8  relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-50 to-transparent"></div>
      <div className="max-w-7xl mx-auto relative z-10 px-4">
        <div className="text-center mb-4 ">
          <h3 className="text-sm font-semibold text-[#D49000]   uppercase tracking-wide">
            Introducing Just Gold
          </h3>
          <h3 className="text-[32px] md:text-[44px] font-semibold text-primary mb-4 md:mb-9 text-center tracking-tight">
            Owning Gold, Made Easy
          </h3>
        </div>

        {/* Slider for small screens */}
        <div className="md:hidden">
          {/* Custom style for wider pagination bullets */}
          <style>{`
            .swiper-pagination-bullet {
              width: 20px;
              height: 4px;
              border-radius: 6px;
              transition: background 0.2s;
            }
            .swiper-pagination-bullet-active {
              background: #11478e;
            }
          `}</style>
          <Swiper
            spaceBetween={16}
            slidesPerView={1}
            centeredSlides={false}
            className="pb-8"
            pagination={{ clickable: true }}
            modules={[Pagination]}
          >
            {features.map((feature, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col items-center  pb-12  h-full ">

                  <div className="mb-2">
                    <div className="flex justify-center items-center p-2 shadow-sm border rounded-2xl">
                      {feature.icon}
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-center ">
                    {feature.title}
                  </h3>
                  <div className="mt-1">
                    <div className=" text-gray-600 text-center">
                      {feature.description}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Grid for medium and larger screens */}
        <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-4 md:p-8 rounded-2xl shadow-sm border border-[#11478e]/10"
            >
              <div className="flex md:flex-col items-start gap-4">
                <div className="bg-gray-50 p-3 rounded-xl">
                  {feature.icon}
                </div>
                <div className="flex flex-col items-start  md:gap-4">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;